import {Injectable} from '@angular/core';
import {ConfigurationModel} from '../../models/configuration.model';
import {ConfigurationService} from '../configuration.service';
import {LokijsService} from './lokijs.service';

@Injectable({
    providedIn: 'root'
})
export class UpdateDatabaseService {

    constructor(private configService: ConfigurationService,
                private loki: LokijsService) {
    }

    updateDatabase() {
        const config: ConfigurationModel = this.configService.getConfiguration();
        if (!config.databaseVersion || config.databaseVersion < 2) {
            this.loki.db.removeCollection('return');
            config.databaseVersion = 2;
            this.configService.saveConfiguration(config);
        }
    }
}
